export default __webpack_public_path__ + "static/media/InfoPhoneFaviconSvg.a2c566cc.svg";